import { Col, Form, Row } from "antd"
import { type FormInstance } from "antd/es/form/hooks/useForm"
import { AnimatePresence, motion } from "motion/react"
import { type NamePath } from "rc-field-form/es/interface"

import InputNumber from "../../../../components/Input/InputNumber.tsx"
import { type TeamMemberMutationData } from "../../types/types.ts"

interface TeamMemberFormCommissionsSectionProps {
  form: FormInstance<TeamMemberMutationData>
}

export function TeamMemberFormCommissionsSection({
  form
}: TeamMemberFormCommissionsSectionProps) {
  const path: NamePath<TeamMemberMutationData> = [
    "permissions",
    "leads",
    "features",
    "lead_assignable_as_sales"
  ]

  const showCommissions =
    Form.useWatch(path, form) ?? form.getFieldValue(path) ?? false

  return (
    <AnimatePresence>
      {showCommissions && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          style={{ overflow: "hidden" }}
        >
          <Row gutter={16}>
            <Col xs={24} md={8}>
              <Form.Item<TeamMemberMutationData>
                label="Main Lead Cost (%)"
                name="office_main_lead_cost"
                rules={[
                  { required: false, message: "Please enter main lead cost" }
                ]}
              >
                <InputNumber
                  size="large"
                  placeholder="0.00"
                  min={0}
                  max={100}
                  precision={2}
                  className="w-full"
                  // disabled={isDisabled}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item<TeamMemberMutationData>
                label="Referral Lead Cost (%)"
                name="office_referral_lead_cost"
                rules={[
                  {
                    required: false,
                    message: "Please enter referral lead cost"
                  }
                ]}
              >
                <InputNumber
                  size="large"
                  placeholder="0.00"
                  min={0}
                  max={100}
                  precision={2}
                  className="w-full"
                  // disabled={isDisabled}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item<TeamMemberMutationData>
                label="Sales Commission (%)"
                name="sales_commission_ratio"
                rules={[
                  { required: false, message: "Please enter commission ratio" }
                ]}
              >
                <InputNumber
                  size="large"
                  placeholder="0.00"
                  min={0}
                  max={100}
                  precision={2}
                  className="w-full"
                  // disabled={isDisabled}
                />
              </Form.Item>
            </Col>
          </Row>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
